import {Box, Flex, Text} from '@chakra-ui/react'
import {useSelector} from 'react-redux'
import useExamRoom from './useExamRoom'
import reviseRequest from '@apis/revise'
import {useState} from 'react'
import GlobalMic3 from '@components/GlobalMic3'

const SpeakingPhrase = ({
  isLoading,
  setIsLoading,
  dataReply,
  setDataReply,
  isShowInput,
  setIsShowInput,
}: {
  isLoading: any
  setIsLoading: any
  dataReply: any
  setDataReply: any
  isShowInput: any
  setIsShowInput: any
}) => {
  const {isDisableReply} = useSelector((state: any) => state.revise)
  const {handlePauseAudio} = useExamRoom()

  const handleStartRecording = () => {
    handlePauseAudio()
  }
  const handleRecordingComplete = async (blob: any) => {
    try {
      setIsLoading(true)
      let file = new File([blob], 'audio.wav', {type: 'audio/wav'})
      const formData = new FormData()
      formData.append('audio_file', file)
      const res = await reviseRequest.getRetrieveTexts(formData)
      if (res?.status === 200) {
        setDataReply(res.data.data.text)
        setIsShowInput(true)
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  return (
    <Flex
      mt={{base: '40px', md: 0}}
      flex={1}
      flexDirection={'column'}
      justifyContent={'space-between'}
      alignItems={'center'}>
      <Flex w={'90%'} ml={'auto'} mb={'16px'} flexDirection={'column'}>
        {/* {isLoading && !dataReply && (
          <Box className="loader-speaking-phrase" ml={'auto'}></Box>
        )} */}
        {dataReply && !isShowInput && (
          <Text
            fontSize={'16px'}
            p={'16px'}
            bg={isDisableReply ? '#F5F5F5' : '#E6F7FF'}
            color={isDisableReply ? 'rgba(0, 0, 0, 0.25)' : '#0050B3'}
            borderRadius={'32px'}
            w={'fit-content'}
            ml={'auto'}
            fontWeight={500}>
            {dataReply}
          </Text>
        )}
      </Flex>
      {!dataReply && !isShowInput && (
        <GlobalMic3
          isDisabled={isDisableReply}
          isLoading={isLoading}
          handleStartRecording={handleStartRecording}
          handleRecordingComplete={handleRecordingComplete}
        />
      )}
    </Flex>
  )
}

export default SpeakingPhrase
